/**
 * Where is this build actually RUNNING — derived from the host, never a baked-in flag.
 *
 * ROOT CAUSE this exists (Sep 2026): one webpack build image is promoted from
 * preview to production unchanged, so `REACT_APP_ENV` is identical on both and
 * cannot tell them apart. It was compiled to "production", which tagged a
 * preview-host chunk failure (event 2d8647b0…) as environment=production and
 * mixed synthetic preview traffic into the real client-impact counts. The
 * hostname is the one thing that differs between the two, so the environment is
 * read from it at runtime.
 *
 * Only gotstaffed.com is production. Everything else that is not localhost is
 * preview — an unknown host is treated as preview so it can never masquerade as
 * production.
 *
 * NOTE: the render watchdog in public/index.html holds its own inline copy of
 * this host logic (an inline HTML script cannot import this module). If the host
 * rules here change, update resolveEnvironment() in that watchdog too.
 */

export const PRODUCTION_HOSTS = ['gotstaffed.com', 'www.gotstaffed.com'];

export function resolveEnvironment(hostname) {
  const host = String(
    hostname != null
      ? hostname
      : typeof window !== 'undefined' && window.location
        ? window.location.hostname
        : '',
  )
    .trim()
    .toLowerCase();

  if (!host || host === 'localhost' || host === '127.0.0.1' || host === '[::1]' || host.endsWith('.local')) {
    return 'development';
  }
  if (PRODUCTION_HOSTS.includes(host)) return 'production';
  return 'preview';
}

/**
 * Manual / synthetic telemetry may only reach a developer's own machine —
 * never the shared preview or production error project.
 */
export function isDeveloperEnvironment(hostname) {
  return resolveEnvironment(hostname) === 'development';
}

export default resolveEnvironment;
